import { createPortal } from 'react-dom';

import JxFormResizableBase from '../../../../JxControls/JxForms/JxFormResizableBase';
import JxTitleBar from '../../../../JxControls/JxTitleBar/JxTitleBar';
import FloatingContentPanelBody from './FloatingContentPanelBody';
import { TITLE_BAR_ACTIONS } from './FloatingContentPanelTitleBarActions';

import '../../../../JxControls/JxTheme.css';
import './FloatingContentPanel.css';

/**
 * FloatingContentPanel — floating resizable JxForm with search + content zones.
 * Extends JxFormResizableBase: drag + resize (4 corners) + bringToTop + Escape to close.
 * Pure painter — no search logic here, all owned by SearchResultProvider via FloatingPanelEngine.
 *
 * @param {boolean}  props.open
 * @param {string}   props.id
 * @param {string}   props.title
 * @param {string}   props.initialQuery
 * @param {function} props.onClose
 */
export default class FloatingContentPanel extends JxFormResizableBase {
    constructor(props) {
        super(props);
        this.name = 'FloatingContentPanel';
        this.schema = null;
    }

    // Literal, hardcoded default — no window.innerWidth centering math.
    getDefaultGeo() {
        return { top: 140, left: 510, width: 900, height: 600 };
    }

    componentDidMount() {
        super.componentDidMount();
        this.bringToTop();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.open && !prevProps.open) {
            this.bringToTop();
        }
    }

    getDisabledHandles() {
        return ['w']; // fcp-hover-strip occupies the left 6px strip — left-edge resize via nw/sw corners
        // return [];
    }

    getTaskbarTitle() {
        return this.props.title || 'Search';
    }

    /**
     *  override base to preven escape from closing
     *
     * @param {*} e
     * @returns
     */
    _handleKeyDown = (e) => {
        // if (e.key !== 'Escape') return;
        // if (!this.props.open) return;
        // //   if (this.state.zIndex !== _topZIndex) return;
        // // cancel window
        // this.handleClose(-1);
    };

    // handleClose = () => {
    //     this.props.onClose?.();
    // };

    render() {
        if (!this.props.open || this.isMinimized) return null;

        const { id, title, initialQuery } = this.props;

        const panel = (
            <div {...this.panelProps} style={this.panelStyle} className={`fcp-panel ${this.panelActiveClass}`}>
                <JxTitleBar
                    id={`${this.name}_titlebar`}
                    title={title || 'No Name'}
                    variant="toolwindow"
                    isDraggable={true}
                    dragHandleProps={this.dragHandleProps}
                    actions={TITLE_BAR_ACTIONS(this.props.onClose)}
                    isMinimizable={true}
                    windowId={this.getId()}
                />
                <FloatingContentPanelBody panelId={id} initialQuery={initialQuery} />

                {/* for resizing sides - has to be in this pannelProps */}
                {this.renderResizeHandles()}
            </div>
        );

        return createPortal(panel, document.body);
    }
}
